<template>
	<transition name="yj-zoom-in-top" @after-leave="doDestroy">
		<div v-show="showPopper" class="yj-autocomplete-suggestion yj-popper" :class="{ 'is-loading': !parent.hideLoading && parent.loading }"
		 :style="{ width: dropdownWidth }" role="region">
			<yj-scrollbar tag="ul" wrap-class="yj-autocomplete-suggestion__wrap" view-class="yj-autocomplete-suggestion__list">
				<li v-if="!parent.hideLoading && parent.loading"><i class="yj-icon-loading"></i></li>
				<slot v-else>
				</slot>
			</yj-scrollbar>
		</div>
	</transition>
</template>
<script>
	import Popper from '@/mixins/vue-popper';
	import Emitter from '@/mixins/emitter';
	import YjScrollbar from '@/components/scrollbar';

	export default {
		mixins: [Popper, Emitter],

		componentName: 'YjAutocompleteSuggestions',

		components: {
			YjScrollbar
		},

		data() {
			return {
				parent: this.$parent,
				dropdownWidth: ''
			};
		},

		props: {
			options: {
				default () {
					return {
						gpuAcceleration: false
					};
				}
			},
			id: String
		},

		methods: {
			select(item) {
				this.dispatch('YjAutocomplete', 'item-click', item);
			}
		},

		updated() {
			this.$nextTick(_ => {
				this.popperJS && this.updatePopper();
			});
		},

		mounted() {
			this.$parent.popperElm = this.popperElm = this.$el;
			this.referenceElm = this.$parent.$refs.input.$refs.input;
			this.referenceList = this.$el.querySelector('.yj-autocomplete-suggestion__list');
			this.referenceList.setAttribute('role', 'listbox');
			this.referenceList.setAttribute('id', this.id);
		},

		created() {
			this.$on('visible', (val, inputWidth) => {
				this.dropdownWidth = inputWidth + 'px';
				this.showPopper = val;
			});
		}
	};
</script>



// WEBPACK FOOTER //
// src/components/autocomplete/src/autocomplete-suggestions.vue